export class UtilsBase {
    FCT;
    constructor(FCT) {
        this.FCT = FCT;
    }
}
//# sourceMappingURL=UtilsBase.js.map